import styles from './styles.module.scss'
import {
  documentToReactComponents,
  Options
} from '@contentful/rich-text-react-renderer'
import { BLOCKS, Document, MARKS } from '@contentful/rich-text-types'
import { ReactNode } from 'react'

function Paragraph({ text }: { text: ReactNode }) {
  return text === '' ? null : <p className={styles.paragraphContent}>{text}</p>
}

const Bold = ({ children }: { children: React.ReactNode }) => (
  <strong>{children}</strong>
)

const options: Options = {
  renderMark: {
    [MARKS.BOLD]: text => <Bold>{text}</Bold>
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <Paragraph text={children} key={`${children}`} />
    ),
    [BLOCKS.EMBEDDED_ASSET]: node => {
      const { url, details } = node.data.target.fields.file

      return (
        <img
          className={styles.svgIcon}
          src={url}
          alt={node.data.target.fields.title}
          width={details.size.width}
          height={details.size.height}
          key={node.data.target.sys.id}
          loading="lazy"
          decoding="async"
        />
      )
    }
  }
}

type FeatureCardsCopyProps = {
  copy: Document[]
}

export default function HeroBannerAnimatedCopy({
  copy
}: FeatureCardsCopyProps) {
  return (
    <div className={styles.copy}>
      {copy.map(node => documentToReactComponents(node, options))}
    </div>
  )
}
